export default {
  state: {
    organizations: [],
    devices: {}
  },
  mutations: {
    setOrganizations (state, payload) {
      state.organizations = payload
    },
    setOrgDevices (state, payload) {
      const newState = state.devices
      newState[payload.orgId] = payload.devices
      state.devices = newState
    }
  },
  actions: {
    setOrganizations ({commit}, payload) {
      commit('setOrganizations', payload)
    },
    setOrgDevices ({commit}, payload) {
      commit('setOrgDevices', payload)
    }
  },
  getters: {
    organizations (state) {
      return state.organizations
    },
    orgDevices (state) {
      return state.devices
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/organizations/index.js